// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"登录","path":"/user/login","parentId":"1","id":"2"},"3":{"name":"选择组织与店铺","path":"/user/select-company-shop","parentId":"1","id":"3"},"4":{"path":"/404","layout":false,"id":"4"},"5":{"path":"/","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/*","parentId":"ant-design-pro-layout","id":"6"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__user__select-company-shop__index" */'@/pages/user/select-company-shop/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__runtime__RouteIndex" */'@/pages/runtime/RouteIndex.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__runtime__RouteDispatcher" */'@/pages/runtime/RouteDispatcher.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/root/workspace/__flow_work/__flow_builds/a7ac760a-4cd6-4492-a056-8f0644420345/workspace/saas-order-frontend_HCAa/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
